import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import UserProfileHealthReport from './Components/UserProfileRoute/UserProfileHealthReport';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function UserProfileHealthReportRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileHealthReportRoutePage">
                    <div className="UserProfileHealthReportRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="UserProfileHealthReportRouteBlock">
                        <UserProfileHealthReport/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default UserProfileHealthReportRoute;